<template>
  <div>
    <b-breadcrumb>
      <b-breadcrumb-item to="/home" @click="updateListCategory">Home</b-breadcrumb-item>
      <b-breadcrumb-item to="/collaborativeList" @click="updateListCategory">Collaborative List</b-breadcrumb-item>
      <b-breadcrumb-item href="#transferListOwnership" active>Transfer List Ownership</b-breadcrumb-item>
    </b-breadcrumb>
    <h1 class="template-name">Transfer List Ownership</h1>
    <p>Transfer your list ownership before you leave.</p>
    <hr>
    <b-tabs content-class="mt-3" active-nav-item-class="font-weight-bold">
      <b-tab title="Administrator">
        <div class="collaborator-container">
          <collaborator-list-cell v-for="administratorCollaborator in collaborativeListAdministrator"
                                  :key="administratorCollaborator.id"
                                  :user-details="administratorCollaborator"
                                  @click.native="setSelectedCollaboratorInformation(administratorCollaborator)"
                                  v-b-modal.transfer-list-ownership-modal></collaborator-list-cell>
        </div>
      </b-tab>
      <b-tab title="Member">
        <div class="collaborator-container">
          <collaborator-list-cell v-for="memberCollaborator in collaborativeListMember" :key="memberCollaborator.id"
                                  :user-details="memberCollaborator"
                                  @click.native="setSelectedCollaboratorInformation(memberCollaborator)"
                                  v-b-modal.transfer-list-ownership-modal></collaborator-list-cell>
        </div>
      </b-tab>
    </b-tabs>

    <!-- Transfer List Ownership Modal -->
    <b-modal id="transfer-list-ownership-modal" title="Leave Collaborative List"
             scrollable no-close-on-backdrop
             hide-footer>
      <div v-if="isCollaboratorAllowedToBeAppointedAsOwner">
        <div class="input-container">
          <b-row>
            <b-col>
              <p class="modal-text">Are you sure you want to appoint "<strong>{{
                selectedCollaboratorInformation.collaboratorName }}</strong>"
                as the new owner of the list?
              </p>
            </b-col>
          </b-row>
        </div>
        <hr>
        <b-button class="main-input-button" block @click="transferListOwnership">Transfer ownership and leave list
        </b-button>
      </div>
      <div v-else>
        <div class="input-container">
          <b-row>
            <b-col>
              <p class="modal-text">You are currently the owner of the list.</p>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import CollaboratorListCell from "../table_cells/collaborator_cell/CollaboratorListCell"
  import {mapActions, mapGetters} from "vuex";
  import {db} from "../../main";
  import firebase from "firebase";
  import router from "../../router";

  export default {
    name: "TransferListOwnership.vue",
    components: {
      collaboratorListCell: CollaboratorListCell
    },
    data() {
      return {
        toDoListId: null,
        toDoListDetails: {},
        collaborativeListAdministrator: [],
        collaborativeListMember: [],
        selectedCollaboratorInformation: {},
        isCollaboratorAllowedToBeAppointedAsOwner: false
      }
    },
    methods: {
      ...mapActions([
        "updateListCategory"
      ]),
      getCollaborativeListCollaborator() {
        this.$bind(
          'collaborativeListAdministrator',
          db
            .collectionGroup('user_collaborative_to_do_list_participation')
            .where('collaborativeToDoListId', '==', this.toDoListId)
            .where('collaborativeToDoListRole', '==', 'Administrator')
            .orderBy('collaboratorName', 'asc')
        )

        this.$bind(
          'collaborativeListMember',
          db
            .collectionGroup('user_collaborative_to_do_list_participation')
            .where('collaborativeToDoListId', '==', this.toDoListId)
            .where('collaborativeToDoListRole', '==', 'Member')
            .orderBy('collaboratorName', 'asc')
        )
      },
      setSelectedCollaboratorInformation(collaboratorInformation) {
        // check if the owner is choosing his/herself
        if (this.$store.getters.user.data.id === collaboratorInformation.collaboratorId) {
          this.isCollaboratorAllowedToBeAppointedAsOwner = false
        } else {
          this.selectedCollaboratorInformation = collaboratorInformation
          this.isCollaboratorAllowedToBeAppointedAsOwner = true
        }
      },
      transferListOwnership() {
        const currentUserId = this.$store.getters.user.data.id

        // make sure that the appointed collaborator become an administrator
        db
          .collection('users/' + this.selectedCollaboratorInformation.collaboratorId + '/user_collaborative_to_do_list_participation')
          .doc(this.selectedCollaboratorInformation.id)
          .update({
            collaborativeToDoListRole: 'Administrator',
            owner: true
          })
        // change list ownership id
        db
          .collection('collaborative_to_do_lists')
          .doc(this.toDoListId)
          .update({
            ownerId: this.selectedCollaboratorInformation.collaboratorId,
            ownerName: this.selectedCollaboratorInformation.collaboratorName,
            toDoListCollaboratorId: firebase.firestore.FieldValue.arrayRemove(currentUserId)
          })
        // remove all the tasks assigned to the previous owner
        db
          .collectionGroup('tasks')
          .where('assigneeId', '==', currentUserId)
          .where('toDoListId', '==', this.toDoListId)
          .where('taskType', '==', 'Collaborative Task')
          .onSnapshot(querySnapshot => {
            querySnapshot.docs.map(doc => doc.ref.update({
              assigned: false,
              assigneeId: null,
              assigneeName: null
            }))
          })
        // remove the owner collaboration from the list
        db
          .collectionGroup('user_collaborative_to_do_list_participation')
          .where('collaboratorId', '==', currentUserId)
          .where('collaborativeToDoListId', '==', this.toDoListId)
          .onSnapshot(querySnapshot => {
            querySnapshot.docs.map(doc => doc.ref.delete())
          })

        this.hideModal('transfer-list-ownership-modal')

        // navigate back to collaborative list
        this.$store.dispatch('updateListCategory', 'collaborativeList')
        router.push({name: 'Collaborative List'})
      },
      hideModal(id) {
        this.$root.$emit('bv::hide::modal', id)
      }
    },
    mounted() {
      this.toDoListId = this.$route.params.collaborativeListId

      // check if the user accessing the page is the owner of the list
      db
        .collection('collaborative_to_do_lists')
        .doc(this.toDoListId)
        .onSnapshot(doc => {
          // if the userId accessing the transfer list ownership page is not the same as the list owner id
          if (doc.data().ownerId !== this.$store.getters.user.data.id) {
            // navigate back to home
            this.$store.dispatch('updateListCategory', 'listCategoryHome')
            router.push({name: 'Home'})
          }
        })

      this.getCollaborativeListCollaborator()
    }
  }
</script>

<style scoped>
  .template-name {
    font-size: 2em;
    margin-bottom: 0.5em;
  }

  .collaborator-container {
    height: 63vh;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .input-container {
    margin-bottom: 1em;
  }

  .modal-text {
    margin-bottom: 0;
  }

  .main-input-button {
    font-weight: bold;
    background-color: #212441;
    padding: 0.5em;
  }

  .main-input-button:hover {
    font-weight: bold;
    background-color: #FFFFFF;
    color: #212441;
    padding: 0.5em;
  }
</style>
